import BsImage from '../icons/BsImage';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import '../styles/ProductGallery.css';
import ResponsiveImage from './ResponsiveImage';
import { IoCloseSharp } from 'react-icons/io5';
// import ZoomableImage from './ZoomableImage';
import ZoomableResponsiveImage from './ZoomableResponsiveImage';


/* This component will be used to display the image of the product
    iBy enabling zoom in for image
    */
const ProductMagnifiedGallery = ({images = [], productTitle, onClose, index}) => {
    const [ activeIndex, setActiveIndex ] = useState(index);

    const imagesWithUrl = images.filter(
        (image) => typeof image.url === 'string' && image.url !== '',
    );

    /** @todo Add "click to expand" feature. */
    return <>
        <h3
            className={'parallax-header'}>
            <span>
                {productTitle}</span>    
            <IoCloseSharp
                onClick={onClose}
                style={{
                // position: 'absolute',
                // top: 1,
                // right: 0,
                    cursor: 'pointer',
                    fontSize: '34px',
                    color: '#000',
                }} /></h3>
        <section
            className={'product-gallery--container'}>
            {/** @todo Load all images in a div. */}
            {/** @todo Switch image position instead of changing the src. */}
            <div
                className={'product-gallery--viewer'}>
                {imagesWithUrl.length < 1 ? <BsImage
                    size={'500px'}
                    fill={'#d3d3d3'} /> : <ZoomableResponsiveImage
                    viewer={true}
                    imageUrl={imagesWithUrl[activeIndex].url}
                    imageAlt={imagesWithUrl[activeIndex].altText || ''}
                    mobileSize={'282px'}
                    desktopSize={'1000px'}></ZoomableResponsiveImage>}
            </div>
            <div
                className={'product-gallery--navigation'}>
                {imagesWithUrl.map((image, index) => <button
                    key={index}
                    className={`product-gallery--thumbnail-button${activeIndex === index ? ' active' : ''}`}
                    onClick={() => setActiveIndex(index)}
                >
                    <ResponsiveImage
                        imageUrl={image.url}
                        imageAlt={image.altText || ''}
                        mobileSize={'75px'}
                        desktopSize={'75px'}></ResponsiveImage>
                    
                </button>)}
            </div>
        </section>
    </>;
};

ProductMagnifiedGallery.propTypes = {
    index: PropTypes.number,
    productTitle: PropTypes.string,
    onClose: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.shape({
        altText: PropTypes.string,
        Attachment: PropTypes.shape({
            localPath: PropTypes.string.isRequired,
        }),
    })),
};

export default ProductMagnifiedGallery;